import * as api from '../../../clients/veranstaltungen';

import {Action} from '@ngrx/store';

export const POST_DOKUMENT_LESE_BERECHTIGUNG_HINZUFUEGEN_MULTI = '[VeranstaltungenModul] PostDokumentLeseBerechtigungHinzufuegenMulti laden';
export const POST_DOKUMENT_LESE_BERECHTIGUNG_HINZUFUEGEN_MULTI_AUSFUEHREN = '[VeranstaltungenModul] PostDokumentLeseBerechtigungHinzufuegenMulti ausführen';
export const POST_DOKUMENT_LESE_BERECHTIGUNG_HINZUFUEGEN_MULTI_ERFOLGREICH = '[VeranstaltungenModul] PostDokumentLeseBerechtigungHinzufuegenMulti laden erfolgreich';
export const POST_DOKUMENT_LESE_BERECHTIGUNG_HINZUFUEGEN_MULTI_FEHLER = '[VeranstaltungenModul] PostDokumentLeseBerechtigungHinzufuegenMulti Ladefehler';
export const POST_DOKUMENT_LESE_BERECHTIGUNG_HINZUFUEGEN_MULTI_NICHT_AUSGEFUEHRT = '[VeranstaltungenModul] PostDokumentLeseBerechtigungHinzufuegenMulti nicht ausgeführt (evtl. Offline)';


export class PostDokumentLeseBerechtigungHinzufuegenMultiAction implements Action {
    readonly type = POST_DOKUMENT_LESE_BERECHTIGUNG_HINZUFUEGEN_MULTI;
        constructor(public dokumentBerechtigungMultiRequest: api.DokumentBerechtigungMultiRequest, public optPayload: any = null) {}
    }
export class PostDokumentLeseBerechtigungHinzufuegenMultiAusfuehrenAction implements Action {
    readonly type = POST_DOKUMENT_LESE_BERECHTIGUNG_HINZUFUEGEN_MULTI_AUSFUEHREN;
        constructor(public dokumentBerechtigungMultiRequest: api.DokumentBerechtigungMultiRequest, public optPayload: any = null) {}
    }
export class PostDokumentLeseBerechtigungHinzufuegenMultiErfolgreichAction implements Action {
    readonly type = POST_DOKUMENT_LESE_BERECHTIGUNG_HINZUFUEGEN_MULTI_ERFOLGREICH;
        constructor(public payload: api.DokumentIdentifier, public dokumentBerechtigungMultiRequest: api.DokumentBerechtigungMultiRequest, public optPayload: any = null) {}
    }
export class PostDokumentLeseBerechtigungHinzufuegenMultiFehlerAction implements Action {
    readonly type = POST_DOKUMENT_LESE_BERECHTIGUNG_HINZUFUEGEN_MULTI_FEHLER;
        constructor(public payload: any, public dokumentBerechtigungMultiRequest: api.DokumentBerechtigungMultiRequest, public optPayload: any = null) {}
    }
export class PostDokumentLeseBerechtigungHinzufuegenMultiNichtAusgefuehrtAction implements Action {
    readonly type = POST_DOKUMENT_LESE_BERECHTIGUNG_HINZUFUEGEN_MULTI_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VeranstaltungenCommandDokumentLeseBerechtigungHinzufuegenMultiActions =
    PostDokumentLeseBerechtigungHinzufuegenMultiAction
    | PostDokumentLeseBerechtigungHinzufuegenMultiAusfuehrenAction
    | PostDokumentLeseBerechtigungHinzufuegenMultiErfolgreichAction
    | PostDokumentLeseBerechtigungHinzufuegenMultiFehlerAction
    | PostDokumentLeseBerechtigungHinzufuegenMultiNichtAusgefuehrtAction
    ;
